<template>
  <UiCard class="poll_wrapper">
    <div slot="title">
      <div class="title">Лимиты API</div>
    </div>

    <div slot="content">
      <span v-if="!limits">API запросов еще не было.</span>
      <div v-else>
        <UiCardContentLine v-for="(l, i) in limits" :key="i" class="card_content_line">
          <span slot="title">{{ l.title }}</span>
          <span slot="value"> {{ l.value }} </span>
        </UiCardContentLine>
      </div>
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiCardContentLine from '@/components/card/UiCardContentLine.vue'

import currentApplicationMixin from './mixins/currentApplicationMixin'

import getNested from '@/utils/getNested'

export default {
  components: { UiCard, UiCardContentLine },
  mixins: [currentApplicationMixin],
  computed: {
    limits() {
      if (!this.$currentApp) return
      if (!this.$currentApp.limits) return null

      return [
        {
          title: 'Отправлено запросов в час',
          value: getNested(this.$currentApp.limits, 'requestsHour'),
        },
        {
          title: 'Лимит запросов в час',
          value: getNested(this.$currentApp.limits, 'requestsHourLimit'),
        },
        {
          title: 'Заблокирован',
          value: getNested(this.$currentApp.limits, 'blocked') ? 'Да' : 'Нет',
        },
        {
          title: 'Всего запросов отправлено',
          value: getNested(this.$currentApp.limits, 'totalRequests'),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.poll_wrapper {
  margin: 0 0 30px 0;
}
</style>
